import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import s from './full-date.scss'

export const FullDate = () => {
  const event = useAppSelector(getEvent)
  const {fullDate} = useEventDateInformation(event.id)

  return (
    <p data-hook="event-full-date" className={classNames(s.dateContainer, s.dateFont)}>
      {fullDate}
    </p>
  )
}
